import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ShopOrdersView } from "src/components/views/erp/production/shopOrder/ShopOrdersView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/production/shopOrders")({
	staticData: { title: i18n.t("shop_orders"), legacyViewKey: "shopOrdersPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <ShopOrdersView isActive={isActive} />;
}
